module.exports = __webpack_public_path__ + "img/20.2bdf7124.png";